import { render, staticRenderFns } from "./enrollStuList.vue?vue&type=template&id=4a8ee253"
import script from "./enrollStuList.vue?vue&type=script&lang=js"
export * from "./enrollStuList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports